import React from 'react';
import {IntegrationCard, IntegrationCardProps} from '@components/integrations/IntegrationCard';

interface IntegrationCardListProps {
  cards: Immutable.List<IntegrationCardProps>;
}

export const IntegrationCardList: React.FC<IntegrationCardListProps> = ({cards}) => {
  const cardNodes = cards.map(card => {
    // card names are unique (because oauth_api.name has a unique constraint), thus suitable for use as a key here.
    return <IntegrationCard key={card.name} {...card} />;
  });
  return <div>{cardNodes}</div>;
};
